// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1337) return "static/chunks/1337-7752c2b431937b46.js";
	if (chunkId === 1433) return "static/chunks/1433-1e9d28e38e6c89dc.js";
	if (chunkId === 1071) return "static/chunks/1071-abdd69c1a4991cdf.js";
	if (chunkId === 5590) return "static/chunks/5590-d2e52b2203448841.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"112":"df3ce8111c7ac0fb","2336":"eeef6f324691bfba","2536":"f83383636ef095a7","3340":"77d1e67439250d51","3833":"04faf3755af85cd5","3924":"2140227c6317f1a3","5841":"fa8c69da1dd1a0f6","6539":"992a5eae175858e7","7400":"c7b76300b3c3617c","8407":"87256b7b841a1229","9354":"ba7e10c5dc4c00f7","9526":"bed23ebeb44f6833"}[chunkId] + ".js";
};